"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_text_format_1 = __importDefault(require("react-text-format"));
const Linkify = ({ children, linkClassName, }) => {
    const customLinkDecorator = (decoratedHref, decoratedText) => {
        return (react_1.default.createElement("a", { href: decoratedHref, target: "_blank", rel: "noreferrer noopener", className: linkClassName }, decoratedText));
    };
    return (react_1.default.createElement(react_text_format_1.default, { allowedFormats: `['URL']`, linkDecorator: customLinkDecorator }, children));
};
exports.default = Linkify;
